import React, { useEffect } from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const useScroll = (dependencies: any[], ref: React.RefObject<HTMLElement>, behavior: 'smooth' | 'auto') => {
    useEffect(() => {
        if (ref.current) {
            ref.current.scrollIntoView({
                behavior,
                block: 'end',
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [...dependencies, ref]);
};
